module.exports = __webpack_public_path__ + "static/media/Elo Hand-01.fc2cbab1.svg";